(function() {
  if (window.__cartItemOptionsInit) return;
  window.__cartItemOptionsInit = true;

  const VISIBLE_ROWS = 5;

  function setLabel(toggle, expanded) {
    const label = toggle.querySelector('.cart-item__options-toggle-label');
    if (!label) return;
    const text = expanded
      ? (toggle.getAttribute('data-hide-text') || 'Hide details')
      : (toggle.getAttribute('data-show-text') || 'Show details');
    if (label.textContent !== text) label.textContent = text;
  }

  function initCartDetailsToggles(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const containers = scope.querySelectorAll('.cart-item__options[data-collapsible]');
    containers.forEach((container) => {
      const rows = container.querySelectorAll('dl .product-option');
      const toggle = container.querySelector('.cart-item__options-toggle');
      if (!toggle) return;

      if (rows.length > VISIBLE_ROWS) {
        container.classList.add('has-more');
        if (!container.dataset.cartOptionsInitialized) {
          container.dataset.cartOptionsInitialized = 'true';
          container.classList.add('collapsed');
          toggle.setAttribute('aria-expanded', 'false');
        }
        setLabel(toggle, toggle.getAttribute('aria-expanded') === 'true');
      } else {
        container.dataset.cartOptionsInitialized = 'true';
        container.classList.remove('has-more', 'collapsed');
      }
    });
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest && event.target.closest('.cart-item__options-toggle');
    if (!toggle) return;
    event.preventDefault();
    const container = toggle.closest('.cart-item__options');
    if (!container) return;
    const expanded = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', String(expanded));
    container.classList.toggle('collapsed', !expanded);
    setLabel(toggle, expanded);
  });

  function observeDrawer() {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer || !window.MutationObserver) return;
    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        initCartDetailsToggles(drawer);
      });
    });
    observer.observe(drawer, { childList: true, subtree: true });
  }

  function start() {
    initCartDetailsToggles(document);
    observeDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('section:load', (event) => {
    initCartDetailsToggles(event.target || document);
  });

  document.addEventListener('cart:updated', (event) => {
    initCartDetailsToggles((event.detail && event.detail.root) || document);
  });

  document.addEventListener('cart-drawer:refresh', () => {
    initCartDetailsToggles(document);
  });
})();
